import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Text } from '../../Text/Text';
import { FlexContainer } from '../../layout/FlexContainer';
import { DataGrid } from '../DataGrid/DataGrid';
export const SameSectionDataGrid = ({ data, config, emptyValue, itemMinWidth, titleTextVariant, sectionKeyExtractor, sectionTitleExtractor, }) => {
    const mappedConfig = data.map((dataItem, index) => {
        const sectionKey = sectionKeyExtractor(dataItem);
        const title = sectionTitleExtractor?.(dataItem);
        const indexedConfig = config.map(({ key, label, render }) => {
            return {
                key,
                label: (labelData) => typeof label === 'function' ? label(labelData, index) : label,
                render: (renderData) => render(renderData, index),
            };
        });
        return (_jsxs(Fragment, { children: [title && _jsx(Text, { variant: titleTextVariant, children: title }), _jsx(DataGrid, { data: dataItem, config: indexedConfig, emptyValue: emptyValue, itemMinWidth: itemMinWidth })] }, sectionKey));
    });
    return (_jsx(FlexContainer, { direction: 'column', gap: '2', children: mappedConfig }));
};
